function Dashboard() {
  return (
    <div>
      <h2 className="mb-3">Dashboard</h2>
    </div>
  );
}

export default Dashboard;
